// src/app/services/badge.service.ts
import { Injectable } from '@angular/core';
import { Badge } from '@capawesome/capacitor-badge';

@Injectable({ providedIn: 'root' })
export class BadgeService {
  async updateBadge(unreadCount: number): Promise<void> {
    const supported = await Badge.isSupported();
    if (supported.isSupported) {
      await Badge.set({ count: unreadCount });
    }
  }

  

  async clearBadge(): Promise<void> {
    const supported = await Badge.isSupported();
    if (supported.isSupported) {
      await Badge.set({ count: 0 });
    }
  }
}
